import React, { useMemo, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import Projects from '../projects/AllProjects';
import InvoiceList from './InvoiceList';
import InvoiceGenerate from './InvoiceGenerate';
import InvoiceDetail from './InvoiceDetail';
import ProjectContext from '../../ProjectContext';
import { useContext } from 'react';

const InvoicesPage = () => {
  const location = useLocation();
  const history = useHistory();
  const [view, setView] = useState('list'); // 'list', 'generate', 'detail'
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);

  const projectDetail = useContext(ProjectContext);
  const projectId = projectDetail.id || new URLSearchParams(location.search).get('projectid');

  if (projectDetail.id === "") {
    history.push("/project/allprojects");
  }

  const invoiceIdFromUrl = useMemo(
    () => new URLSearchParams(location.search).get('invoiceId'),
    [location.search]
  );

  const handleGenerate = () => setView('generate');
  const handleBackToList = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete('invoiceId'); // remove invoiceId from the query params
    history.push({ search: searchParams.toString() });
    setView('list');
  };
  // const handleSelectInvoice = (id) => {
  //   setSelectedInvoiceId(id);
  //   setView('detail');
  // };
  const handleBack = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete('invoiceId');
    history.push({ search: searchParams.toString() });
  };

  const handleGenerateSuccess = (id) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('invoiceId', id);
    history.push({ search: searchParams.toString() });
    setView('detail');
  };

  const handleSelectInvoice = (id) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('invoiceId', id);
    history.push({ search: searchParams.toString() });
    setView('detail');
  };

  return (
    <div className='content mt-4'>
      {view === 'list' && (
        <InvoiceList
          projectId={projectId}
          onGenerate={handleGenerate}
          onSelectInvoice={handleSelectInvoice}
        />
      )}
      {view === 'generate' && (
        <InvoiceGenerate
          projectId={projectId}
          onSuccess={handleGenerateSuccess}
          onCancel={handleBackToList}
        />
      )}
      {view === 'detail' && (
        <InvoiceDetail
          projectId={projectId}
          invoiceId={invoiceIdFromUrl}
          onBack={handleBackToList}
        />
      )}
    </div>
  );
};

export default InvoicesPage; 